/**
 * Calcula o percentual de ocupação com mínimo inicial por posição da data.
 * 
 * Regras:
 * - 1ª data (mais próxima): mínimo 30%
 * - 2ª data: mínimo 25%
 * - 3ª data em diante: mínimo 20%
 * - O percentual só sobe quando a ocupação real ultrapassar o mínimo
 * 
 * @param {number} maxSpots - Capacidade total da data
 * @param {number} spotsAvailable - Vagas ainda disponíveis
 * @param {number} dateIndex - Posição da data (0-based) entre as datas futuras ordenadas
 * @returns {{ percentage: number, isSoldOut: boolean }}
 */
export const getOccupancyPercentage = (maxSpots, spotsAvailable, dateIndex = 0) => {
  if (!maxSpots || maxSpots <= 0) return { percentage: 0, isSoldOut: false };

  const sold = maxSpots - (spotsAvailable || 0);
  const realPercentage = Math.round((sold / maxSpots) * 100);
  const isSoldOut = spotsAvailable <= 0;

  // Mínimos por posição: 1ª=30%, 2ª=25%, 3ª+=20%
  const minPercentages = [30, 25, 20];
  const minPercentage = minPercentages[Math.min(dateIndex, minPercentages.length - 1)];

  return {
    percentage: Math.max(realPercentage, minPercentage),
    isSoldOut
  };
};

/**
 * Filtra datas futuras e ordena cronologicamente.
 * @param {Array} dates - Array de datas do pacote
 * @returns {Array} Datas futuras ordenadas por start_date
 */
export const getFutureDatesSorted = (dates) => {
  if (!dates || !Array.isArray(dates)) return [];
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return dates
    .filter(d => {
      if (!d.start_date) return false;
      const startDate = new Date(d.start_date.split('T')[0] + 'T00:00:00');
      return startDate >= today;
    })
    .sort((a, b) => {
      const dateA = new Date(a.start_date.split('T')[0] + 'T00:00:00');
      const dateB = new Date(b.start_date.split('T')[0] + 'T00:00:00');
      return dateA - dateB;
    });
};

export const isDateUnavailable = (d) => !d || (d.spots_available ?? 0) <= 0 || !!d.sales_closed;

export const isPackageClosed = (dates) => {
  const future = getFutureDatesSorted(dates);
  return future.length === 0 || future.every(isDateUnavailable);
};
